module.exports = __webpack_public_path__ + "static/media/n_icon_shuoming.c6c83bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_shuoming.png
// module id = 674
// module chunks = 0 1